import React from 'react';
import { useTranslation } from 'react-i18next';
import { Google } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

export type GoogleButtonProps = {
  isLoading?: boolean;
  onClick: () => void;
};

export const GoogleButton: React.FC<GoogleButtonProps> = ({
  isLoading,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      variant={Variants.Contained}
      size={Sizes.Large}
      color={Colors.White}
      onClick={onClick}
      startIcon={Google}
      disabled={isLoading}
      fullWidth
      alignCenter
    >
      {t('forms.login.third-party.google.label')}
    </Button>
  );
};
